// store/Playlists/playlistsSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchPlaylists,
  createPlaylist,
  fetchPlaylistCalls,
  markPlaylistAsReviewed,
  getPlaylistRecordingPlaybackUrl,
} from "./playlistsThunks";

const playlistsSlice = createSlice({
  name: "playlists",
  initialState: {
    playlists: [],
    total: 0,
    loading: false,
    error: null,
    filters: [],
    sortModel: [],
    currentPage: 1,
    pageSize: 200,
    hasMore: true,

    playlistCalls: [],
    playlistCallsLoading: false,
    playlistCallsError: null,
    playlistCallsPage: 1,
    playlistCallsHasMore: true,
    loadingPlayback: false,
    playbackError: null,
  },
  reducers: {
    setFilters(state, action) {
      state.filters = [...state.filters, ...action.payload];
      state.currentPage = 1;
      state.playlists = [];
      state.hasMore = true;
    },
    setSortModel(state, action) {
      state.sortModel = action.payload;
      state.currentPage = 1;
      state.playlists = [];
      state.hasMore = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlaylists.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlaylists.fulfilled, (state, action) => {
        state.loading = false;
        const { data, page } = action.payload;
        const playlists = data.data;

        if (page === 1) {
          state.playlists = playlists;
        } else {
          state.playlists = [...state.playlists, ...playlists];
        }

        state.currentPage = page;
        state.hasMore = playlists.length === state.pageSize;
      })
      .addCase(fetchPlaylists.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createPlaylist.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPlaylist.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createPlaylist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchPlaylistCalls.pending, (state) => {
        state.playlistCallsLoading = true;
        state.playlistCallsError = null;
      })
      .addCase(fetchPlaylistCalls.fulfilled, (state, action) => {
        state.playlistCallsLoading = false;
        const { data, page } = action.payload;
        const calls = data.data.recorded_calls;

        if (page === 1) {
          state.playlistCalls = calls;
        } else {
          state.playlistCalls = [...state.playlistCalls, ...calls];
        }

        state.playlistCallsPage = page;
        state.playlistCallsHasMore = calls.length === state.pageSize;
      })
      .addCase(fetchPlaylistCalls.rejected, (state, action) => {
        state.playlistCallsLoading = false;
        state.playlistCallsError = action.payload;
      })
      .addCase(markPlaylistAsReviewed.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(markPlaylistAsReviewed.fulfilled, (state, action) => {
        state.loading = false;

        // Optionally update the playlist in the state if needed:
        const updated = action.payload;
        const index = state.playlists.findIndex((p) => p.id === updated.id);
        if (index !== -1) {
          state.playlists[index] = {
            ...state.playlists[index],
            ...updated,
          };
        }
      })
      .addCase(markPlaylistAsReviewed.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getPlaylistRecordingPlaybackUrl.pending, (state) => {
        state.loadingPlayback = true;
        state.playbackError = null;
      })
      .addCase(getPlaylistRecordingPlaybackUrl.fulfilled, (state) => {
        state.loadingPlayback = false;
      })
      .addCase(getPlaylistRecordingPlaybackUrl.rejected, (state, action) => {
        state.loadingPlayback = false;
        state.playbackError = action.payload;
      });
  },
});

export const { setFilters, setSortModel } = playlistsSlice.actions;
export default playlistsSlice.reducer;
